<!--
 @description 告警走势图-表格组件
 @date 2018/11/21
-->
<template>
  <div>
    <el-row :gutter="20" justify="space-between" align="middle" type="flex">
      <el-col :span="8"><div class="alarm-table-title" v-text="tableInfo.title"></div></el-col>
      <el-col :span="8"><div class="alarm-table-time" v-text="tableInfo.time"></div></el-col>
      <el-col :span="8">
        <div class="alarm-page-control ilb">
          <i class="iconfont icon-shangjiantou left-arrow"
            :class="{'arrow-active' : tableInfo.currentPage > 1 }"
            @click="prevPage"></i>
          <div class="page-bullet-wrap ilb" v-for="(item, index) in Math.ceil(tableInfo.totalCount / 5)" :key="'key' + index">
            <span class="page-bullet" :class="{'bullet-active' : index + 1 === tableInfo.currentPage }"></span>
          </div>
          <i class="iconfont icon-shangjiantou right-arrow"
            :class="{'arrow-active' : tableInfo.currentPage < Math.ceil(tableInfo.totalCount / 5) }"
            @click="nextPage"></i>
        </div>
      </el-col>
    </el-row>
    <table class="table-wrap" v-if="alarmType == 1">
      <thead class="t-head">
        <tr>
          <th class="t-border" v-text="$t('alarmTrend.rank')"></th>
          <th class="t-border" v-text="$t('alarmTrend.alarmName')"></th>
          <th class="t-border" v-text="$t('alarmTrend.group')"></th>
          <th class="t-border" v-text="$t('alarmTrend.count')"></th>
          <th class="t-border" v-text="$t('alarmTrend.trend')"></th>
        </tr>
      </thead>
      <tbody v-show="tableList.length > 0">
        <tr v-for="(item, index) in tableList" :key="item.key" :class="{'even-bg': (index + 1) % 2 === 0 }">
          <td class="t-border" v-text="item.rank" :title="item.rank"></td>
          <td class="t-border" v-text="item.alarmName" :title="item.alarmName"></td>
          <td class="t-border" v-text="item.group" :title="item.group"></td>
          <td class="t-border" v-text="item.count" :title="item.count"></td>
          <td class="t-border">
            <div v-show="item.trend === '3'" class="no-trend"></div>
            <i class="iconfont" 
            :class="[{'icon-jiantou_xiangxia' : item.trend === '2'}, 
            {'icon-jiantou_xiangshang' : item.trend === '1'},
            {'trend-down' : item.trend === '2'}, 
            {'trend-up' : item.trend === '1'}]"></i>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table-wrap" v-else>
        <thead class="t-head">
          <tr>
            <th class="t-border" v-text="$t('alarmTrend.host')"></th>
            <th class="t-border" v-text="$t('alarmTrend.description')"></th>
            <th class="t-border" v-text="$t('alarmTrend.time')"></th>
            <th class="t-border" v-text="$t('alarmTrend.age')"></th>
          </tr>
        </thead>
        <tbody v-show="tableList.length > 0">
          <tr v-for="(item, index) in tableList" :key="item.key" :class="{'even-bg': (index + 1) % 2 === 0 }">
            <td class="t-border" v-text="item.name" :title="item.name"></td>
            <td class="t-border" 
            :class="{'information-bg': item.priority == 1,
            'warning-bg': item.priority == 2,
            'average-bg': item.priority == 3,
            'high-bg': item.priority == 4,
            'disaster-bg': item.priority == 5 }" 
            v-text="item.description" 
            :title="item.description"
            @click="toZabbix()"></td>
            <td class="t-border" v-text="item.time" :title="item.time"></td>
            <td class="t-border" v-text="item.age" :title="item.age"></td>
          </tr>
        </tbody>
      </table>
    <div v-show="tableList.length === 0" v-text="$t('common.noData')" class="no-data"></div>
  </div>
</template>

<script>
  import tab from '@/views/layout/components/setTab'
  export default {
    props: {
      tableInfo: {
        type: Object
      },
      tableList: {
        type: Array
      },
      alarmType: {
        type: String,
        default: '1'
      }
    },
    methods: {
      prevPage () {
        if (this.tableInfo.currentPage <= 1) return
        this.$emit('prevpage', this.tableInfo.currentPage - 1)
      },
      nextPage () {
        if (this.tableInfo.currentPage >= Math.ceil(this.tableInfo.totalCount / 5)) return
        this.$emit('nextpage', this.tableInfo.currentPage + 1)
      },
      toZabbix () {
        this.$router.push({ path: '/home/zabbixMonitor' })
        tab.selectTab('zabbixMonitor')
      }
    }
  }
</script>

<style scoped>
  .no-data {
    text-align: center;
    height: 170px;
    line-height: 140px;
    font-weight: bolder;
  }
  .col-height {
    min-height: 238px;
  }
  .table-wrap {
    width: 100%;
    margin-top: 4px;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #ddd;
  }
  .t-head .t-border {
    background-color: #f1f1f1;
    color: #333;
    font-weight: bolder;
    font-size: 14px;
  }
  .even-bg {
    background-color: #f1f1f1;
  }
  .t-border {
    font-size: 12px;
    color: #666;
    height: 30px;
    width: 110px;
    min-width: 40px;
    max-width: 220px;
    padding: 2px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .no-trend {
    display: block;
    width: 16px;
    height: 3px;
    background: #007aff;
    margin: auto;
  }
  .t-border .iconfont {
    font-weight: bolder;
    font-size: 20px;
  }
  .trend-up {
    color: red;
  }
  .trend-down {
    color: green;
  }
  .alarm-table-title {
    font-weight: bolder;
    font-size: 16px;
  }
  .alarm-table-time {
    text-align: center;
    font-size: 14px;
  }
  .alarm-page-control {
    float: right;
  }
  .alarm-page-control .iconfont {
    font-size: 10px;
    display: inline-block;
    font-weight: bolder;
    color: #000;
    opacity: .3;
  }
  .alarm-page-control .left-arrow {
    display: inline-block;
    cursor: pointer;
    transform: rotate(-90deg);
  }
  .alarm-page-control .right-arrow {
    display: inline-block;
    cursor: pointer;
    transform: rotate(90deg);
  }
  .page-bullet-wrap {
    padding: 0 2px;
  }
  .alarm-page-control .page-bullet {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: .2;
  }
  .alarm-page-control .bullet-active {
    opacity: 1;
    background: #007aff;
  }
  .alarm-page-control .arrow-active {
    opacity: 1;
    color: #007aff;
  }
  .table-wrap .normal-bg {
    background-color: #fff;
  }
  .table-wrap .information-bg {
    background-color: #59db8f;
    color: #f1f1f1;
  }
  .table-wrap .warning-bg {
    background-color: #FFC859;
    color: #f1f1f1;
  }
  .table-wrap .average-bg {
    background-color: #FFA059;
    color: #f1f1f1;
  }
  .table-wrap .high-bg {
    background-color: #E97659;
    color: #f1f1f1;
  }
  .table-wrap .disaster-bg {
    background-color: #E45959;
    color: #f1f1f1;
  }
  .table-wrap td {
    cursor: pointer;
  }
</style>